import { useQuery } from '@tanstack/react-query'
import { api } from '../lib/api'
import { useAuthStore } from '../stores/authStore'

interface RispostaNotifiche {
  feedback_non_letti: number
}

/**
 * Polling 10s del contatore feedback non letti.
 *
 * Il job di generazione feedback è asincrono (può durare 30-60s per sessioni
 * lunghe), quindi la sidebar deve scoprire da sola quando un feedback diventa
 * pronto. Endpoint backend molto leggero (solo COUNT con indice mirato).
 */
export function useNotifiche(): { feedbackNonLetti: number } {
  const token = useAuthStore((s) => s.token)

  const q = useQuery({
    queryKey: ['notifiche-feedback'],
    queryFn: async () =>
      (await api.get<{ dati: RispostaNotifiche }>('/sessions/notifiche')).data.dati!,
    refetchInterval: 10_000,
    refetchIntervalInBackground: true,
    // Disattiva quando non c'è auth (evita loop di errori 401 prima del login)
    enabled: !!token,
  })

  return { feedbackNonLetti: q.data?.feedback_non_letti ?? 0 }
}
